/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PerformanceItemCreateRequest } from '../models/PerformanceItemCreateRequest';
import type { PerformanceItemResponse } from '../models/PerformanceItemResponse';
import type { PerformanceItemUpdateRequest } from '../models/PerformanceItemUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PerformanceItemService {
    /**
     * Create Performance Item
     * 성과 항목 생성
     *
     * 새로운 성과 항목을 생성합니다.
     * @returns PerformanceItemResponse Created
     * @throws ApiError
     */
    public static appsPerformanceViewsCreatePerformanceItem({
        requestBody,
    }: {
        requestBody: PerformanceItemCreateRequest,
    }): CancelablePromise<PerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/performance/item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Performance Items
     * 성과 항목 목록 조회
     *
     * 특정 성과의 성과 항목들을 조회합니다.
     *
     * Args:
     * performance_id: 성과 ID (필수)
     * @returns PerformanceItemResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsListPerformanceItems({
        performanceId,
    }: {
        performanceId?: string,
    }): CancelablePromise<Array<PerformanceItemResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/item',
            query: {
                'performance_id': performanceId,
            },
            errors: {
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Performance Item
     * 성과 항목 조회
     *
     * ID로 특정 성과 항목을 조회합니다.
     * @returns PerformanceItemResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsGetPerformanceItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<PerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Performance Item
     * 성과 항목 정보 수정
     *
     * 특정 성과 항목의 정보를 수정합니다.
     * @returns PerformanceItemResponse OK
     * @throws ApiError
     */
    public static appsPerformanceViewsUpdatePerformanceItem({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: PerformanceItemUpdateRequest,
    }): CancelablePromise<PerformanceItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Performance Item
     * 성과 항목 삭제
     *
     * 특정 성과 항목을 삭제합니다.
     * @returns void
     * @throws ApiError
     */
    public static appsPerformanceViewsDeletePerformanceItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/performance/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
